"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 318"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.99902 0C6.41324 0 6.74902 0.335786 6.74902 0.75V11.25C6.74902 11.6642 6.41324 12 5.99902 12C5.58481 12 5.24902 11.6642 5.24902 11.25V0.75C5.24902 0.335786 5.58481 0 5.99902 0Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 5.99902C0 5.58481 0.335786 5.24902 0.75 5.24902H11.25C11.6642 5.24902 12 5.58481 12 5.99902C12 6.41324 11.6642 6.74902 11.25 6.74902H0.75C0.335786 6.74902 0 6.41324 0 5.99902Z",
    fill: fill
  })));
};

exports["default"] = _default;